import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormListItemDTO } from '@sb-tools/typescript/models/dto/form-list-item.dto';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';
import { InlineSVGComponent } from '../../Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'app-forms-list',
    templateUrl: './forms-list.component.html',
    styleUrls: ['./forms-list.component.scss'],
    imports: [LoaderComponent, InlineSVGComponent],
})
export class FormsListComponent {
    @Input() areFormsLoading: boolean;
    @Input() forms: FormListItemDTO[];
    @Output() formSelected: EventEmitter<FormListItemDTO> = new EventEmitter();
}
